import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const imageUrl = (id, variant) => `${API}/photos/${id}/image${variant ? `?variant=${variant}` : ""}`;
export const videoUrl = (id) => `${API}/photos/${id}/video`;
export const assetUrl = (path) => (!path ? null : path.startsWith("http") ? path : `${BACKEND_URL}${path}`);

// Small grid-thumbnail URL (swaps variant=display -> variant=thumb for fast, cached grids).
export const thumbUrl = (path) => {
  const u = assetUrl(path);
  if (!u) return u;
  if (/variant=\w+/.test(u)) return u.replace(/variant=\w+/, "variant=thumb");
  return u + (u.includes("?") ? "&" : "?") + "variant=thumb";
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const DOMAINS = ["Travel", "Food", "Institutions", "Events", "Geographic", "Nature", "Objects", "People", "Other"];
export const BRAND_BANNER = "https://customer-assets-39nsmqrw.emergentagent.net/job_geo-photo-engine/artifacts/l0kqvis1_IMG_7857.png";
export const PRIVACY_LEVELS = ["private", "family", "friends", "group", "institution", "community", "public", "website"];
export const NATURE_TYPES = ["plant", "tree", "flower", "insect", "bird", "animal", "fungus", "other"];
